import { useEffect } from 'react';

/** Active only while wizard step 3 (Photos) is mounted */
export const PHOTOS_STEP_BODY_LOCK_CLASS = 'photos-step-scroll-lock';

/**
 * Prevents page-level y-scroll on the Photos step (tall photo grids were growing the document).
 * Step content still scrolls inside WizardStepLayout. Cleared when leaving step 3.
 */
export default function usePhotosStepBodyScrollLock() {
    useEffect(() => {
        const { documentElement: html, body } = document;
        html.classList.add(PHOTOS_STEP_BODY_LOCK_CLASS);
        body.classList.add(PHOTOS_STEP_BODY_LOCK_CLASS);

        return () => {
            html.classList.remove(PHOTOS_STEP_BODY_LOCK_CLASS);
            body.classList.remove(PHOTOS_STEP_BODY_LOCK_CLASS);
        };
    }, []);
}
